import {RootState} from '../../store';

const key = 'aliases';

// FNP-950: the `records` sub-reducer is gone - records live in React Query.
// What remains in Redux for this module is SELECTION (the checkbox set, the
// platform standard per FNP-951) and VISIBILITY (page, limit, keyword,
// columns).
//
// The old visibilitySelector also returned `items`, `visibleItems`,
// `visibleCount` and `totalPages` derived from `records.*` - a slice nothing
// ever populated. Those values were computed and then discarded by every
// caller: the tables take their counts from the React Query hook
// (`useAliases`) and use token pagination + infinite scroll, not page numbers.
// They are removed rather than rewired, because nothing consumed them.

export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};

export const visibilityStateSelector = (state: RootState) => {
    return state[key].visibility;
};
